import { useState } from "react";

const MissingSolarGradeWarning = ({ missingKeys, sectionName }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const missingFieldNames = missingKeys.map((key) => {
		const prefix = `${sectionName} - `;
		return key.startsWith(prefix) ? key.slice(prefix.length) : key;
	});

	if (missingKeys.length === 0) {
		return null;
	}

	return (
		<>
			<button
				onClick={() => setIsModalOpen(true)}
				className="flex items-center gap-2 px-3 py-2 bg-yellow-100 hover:bg-yellow-200 text-yellow-800 border border-yellow-300 rounded-md text-sm font-medium transition-colors">
				{missingKeys.length} Solar Grade Field{missingKeys.length !== 1 ? "s are not in" : " is not in"} the Krummy Capture Template. Click to see more
				information.
			</button>

			{isModalOpen && (
				<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[3000]">
					<div className="bg-white z-[3002] rounded-lg shadow-xl max-w-md w-full max-h-96 flex flex-col">
						<div className="flex items-center justify-between p-4 border-b">
							<h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">Missing Solar Grade Fields</h2>
							<button onClick={() => setIsModalOpen(false)} className="text-gray-400 hover:text-gray-600 transition-colors"></button>
						</div>

						<div className="p-4 flex-1 overflow-y-auto">
							<p className="text-sm text-gray-600 mb-4">
								The following fields have solar grade data but are not configured in section "{sectionName}":
							</p>

							<ul className="space-y-2">
								{missingFieldNames.map((fieldName, index) => (
									<li key={index} className="flex items-center gap-2 text-sm">
										<div className="w-2 h-2 bg-yellow-500 rounded-full flex-shrink-0"></div>
										<span className="font-mono text-gray-800">{fieldName}</span>
									</li>
								))}
							</ul>
						</div>

						<div className="p-4 border-t bg-gray-50 rounded-b-lg">
							<button
								onClick={() => setIsModalOpen(false)}
								className="w-full px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium transition-colors">
								Close
							</button>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default MissingSolarGradeWarning;
